import { useEffect } from 'react';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  noindex?: boolean;
}
const DEFAULT_OG_IMAGE = 'https://i.ytimg.com/vi/HXlFRCbmWiM/maxresdefault.jpg';
export function SEO({
  title,
  description,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = 'website',
  noindex = false
}: SEOProps) {
  useEffect(() => {
    document.title = title;
    document.documentElement.setAttribute('lang', 'de');
    const setMeta = (key: string, content: string, attr: 'name' | 'property' = 'name') => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', description);
    setMeta('robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', ogType, 'property');
    setMeta('og:image', ogImage, 'property');
    setMeta('og:locale', 'de_DE', 'property');
    setMeta('og:site_name', 'CRM Kraft – Close CRM Agentur', 'property');
    if (canonical) setMeta('og:url', canonical, 'property');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', ogImage);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }

    // German-only site: remove any stale alternate-language links
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
  }, [title, description, canonical, ogImage, ogType, noindex]);
  return null;
}